import React from 'react'
import { Eye } from '@phosphor-icons/react'

import { formatTimeRange } from '@/utils/date/format-time-range'

import { formatDateTime, formatPermissions } from '../utils'

const formatAdditionalInfo = (t, unit, phone) => {
  if (!unit && !phone) {
    return <span>{t('visitors:columns.notAvailable')}</span>
  }

  return (
    <React.Fragment>
      {unit && <span>{unit}</span>}
      {unit && phone && <span> | </span>}
      {phone && <span>{phone}</span>}
    </React.Fragment>
  )
}

export const getHistoryColumns = (t, onDetailsClick, timezone) => [
  {
    Header: t('visitors:columns.checkInDateTime'),
    accessor: 'date',

    Cell: ({ row }) => {
      const { date, time } = formatDateTime(row.original.date, timezone)
      return (
        <div className="check-in-cell">
          <div>{date}</div>
          <div className="check-in-time">{time}</div>
        </div>
      )
    },
  },
  {
    Header: t('visitors:columns.guestVendorName'),
    accessor: 'name',

    Cell: ({ row }) => {
      const type = row.original.type || t('visitors:columns.notAvailable')

      return (
        <div className="visitor-name-cell">
          <div>{row.original.name}</div>
          {/* Only show type if it's not "guest" */}
          {type.toLowerCase() !== 'guest' && <div className="additional-info">{type}</div>}
        </div>
      )
    },
  },
  {
    Header: t('visitors:columns.permissions'),
    accessor: 'permissions',

    Cell: ({ row }) => {
      const permission = formatPermissions(row.original, timezone)
      const permissionTime = formatTimeRange(row.original.startTime, row.original.endTime, timezone)

      return (
        <div className="permission-cell">
          <div>{permission}</div>
          <div className="permission-time">{permissionTime}</div>
        </div>
      )
    },
  },
  {
    Header: t('visitors:columns.residentUnit'),
    accessor: 'resident',

    Cell: ({ row }) => {
      const residentName = row.original.client || ''
      const unit = row.original.unit || ''
      const phone = row.original.phone || ''

      if (!residentName && !unit) {
        return <div>-</div>
      }

      return (
        <div className="resident-cell">
          <div>{residentName || '-'}</div>
          <div className="additional-info">{formatAdditionalInfo(t, unit, phone)}</div>
        </div>
      )
    },
  },
  {
    Header: t('visitors:columns.actions'),
    accessor: 'actions',

    Cell: ({ row }) => (
      <div className="actions">
        <button
          className="icon-button button button-transparent"
          onClick={() => onDetailsClick(row.original)}
        >
          <Eye size={20} />
        </button>
      </div>
    ),
  },
]
